import { render } from "./VersionChecker.vue?vue&type=template&id=18223540&ts=true"
import script from "./VersionChecker.vue?vue&type=script&lang=ts"
export * from "./VersionChecker.vue?vue&type=script&lang=ts"

import exportComponent from "/home/cipherx/.thelounge-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/VersionChecker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18223540"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18223540', __exports__)) {
    api.reload('18223540', __exports__)
  }
  
  module.hot.accept("./VersionChecker.vue?vue&type=template&id=18223540&ts=true", () => {
    api.rerender('18223540', render)
  })

}


export default __exports__